export default __webpack_public_path__ + "static/media/exit.13bb405d.svg";